import { CaptionStyles, CaptionLineConfig } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const sleek: Partial<CaptionStyles> = {
  theme_preset: 'sleek',
  pageStyle: {
    color: '#0e172b',
    background: '#ffffffc2',
    borderRadius: '16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('AlbertSans.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 84,
  transitions: {
    pageIn: TransitionInEffect.Fade
  }
};

export default sleek;
